import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCase } from '../../../basecase';
import { NativeService, HttpCustomerService, MessageclientService } from 'src/service';
import { CommonService } from 'src/service/common.service';
import { IonInfiniteScroll, Platform, ModalController } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseModal } from 'src/model';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from 'src/model/common';
declare var app;
@Component({
  selector: 'app-inventory-audit-list',
  templateUrl: './inventory-audit-list.component.html',
  styleUrls: ['./inventory-audit-list.component.scss']
})
export class InventoryAuditListComponent extends GridBaseCase {
  auditsearchValue: any;
  productShow: boolean = false;

  tabsIndex: number = 0;//tab切换类型
  searchValue: string = null;//查询内容
  timeShow: boolean = false;
  month: any = new Date();

  pageName: string = null;
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  dataArrayList: Array<any> = [];//数据列表
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    private native: NativeService,
    public baseService: BaseCase,
    public base: BaseModal,
    public modal: ModalController,
  ) {
    super();
    this.baseService.FixedSubmitBtn.configName = "InventoryAuditList";
    this.baseService.FixedSubmitBtn.isShow = true;
    this.baseService.FixedSubmitBtn.text = "批量驳回";
    this.baseService.FixedSubmitBtn.type = 24;
    console.log("库存审批");
    this.LoadData(1);
  }

  ngOnInit() 
  {
  }
  // 搜索条件
  serarEvent(e, type: string = 'type') {
    this.LoadData(1);
  }

  // checkboxChange(event, item) {
  //   // item.isCheck = !item.isCheck;
  //   console.log("checkbox change");
  // }
  checkItem(item,i,event){
    const that=this;
    if (item.isCheck) {
      item.isCheck = false;
    } else {
      item.isCheck = true;
    }
    let istrue:number=0;
    that.dataArrayList.forEach(items => {
      if(items.isCheck){
        istrue++;
      }
    });
    if(istrue==that.dataArrayList.length){
      that.baseService.FixedSubmitBtn["isCheckAll"]=true;
    }else{
      that.baseService.FixedSubmitBtn["isCheckAll"]=false;
    }
  }

  //提交按钮
  EventSubmitClick(btnType: any = true) {
    var that=this;
    if (btnType) {
      console.log("GiftAuditList 通过");
    } else {
      console.log("GiftAuditList  拒绝");
    }
    console.log("提交 json", this.baseService.arrayData);
    console.log("提交 json", this.dataArrayList);
    let ids=[];
    that.dataArrayList.forEach(item => {
      if(item.isCheck)
      {
        ids.push(item.BatchNumber);
      }
    });
    if(!that.dataArrayList.find(n=>n.isCheck==true))
    {
      that.msg.Alert("请选中一条数据");
      return;
    }

    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;

    body.ConfigName = "ApproveProductPurchase";
    body.OpType = "edite";
    body.ConfigType = "form";
    body.RowsPerPage = 1000;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let typeObj = {};
    //ExamineState  1 审批通过  2 审批拒绝  
    typeObj["State"] = btnType?1:2;
    typeObj["BatchNumbers"]=ids;
    body.RequestBody = JSON.stringify(typeObj);
    that.msg.Loading("请稍后...").then(loads => {
      that.http.post(app.DEFAULTURL, body).then(data => {
        setTimeout(function(){
          loads.dismiss();
        },100);
        if (data.ResponseMessage.Success) {
         that.msg.Alert("操作成功！");
         that.LoadData(1);
        } else {
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      }).catch(err => {
        loads.dismiss();
        that.msg.Alert("网络异常，请稍后再试！");
      });
     
    })
  }
  tabsEvent(num) {
    const that = this;
    this.tabsIndex = num;
    if (num === 1) {
      that.timeShow = true;
    } else {
      that.timeShow = false;
    }
  }

  // 下边列表显示
  arrowSee(event, item,i) {
    const that = this;
     item.productShow = true;
    if (item.BatchNumber) {
      const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      let body = new WebParameterContext();
      body.Account = that.com.GetAccount;
      body.ConfigName = "GetProductPurchaseUnApprovalDetails";
      body.OpType = "query";
      body.ConfigType = "view";
      body.RowsPerPage = 1000;
      body.PageNumber = 1;
      body.Client.PageName = PageName;
      body.Client.ApiType = "Element";
      body.Client.Name = that.element.name;
      body.Client.ClientType = 2;
      if (that.platform.is("android")) {
        body.Client.ClientType = 0;
      } else if (that.platform.is("ios")) {
        body.Client.ClientType = 1;
      }
      let typeObj = {};
      //ExamineState  1 审批通过  2 审批拒绝  3 待审批   4 无需审批
      typeObj["batchNumber"] = item.BatchNumber || "";
      body.RequestBody = JSON.stringify(typeObj);
      that.http.post(app.DEFAULTURL, body).then(data => {
        if (data.ResponseMessage.Success) {
          data.Status.Datas = data.Status.Status.Datas || [];
          if (data.Status && data.Status.Datas) {
            item["detailList"] = data.Status.Datas;
          }
        }

      }).catch(error => {
        that.apiObj['status'] = false;
        that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
        that.loading = true;
        // console.log(error);
      });
    }

  }
  // 下拉列表隐藏
  arrowhide(event, item) {
    const that = this;
    item.productShow = false;
  }

  // 日期查询
  EventDateTimeClick() {
    console.log("测试1");
    let that = this;
    console.log(that.month);
    let _obj = {
      value: that.month,
      format: "yyyymmdd"
    };
    that.native.IosselectDateTime(_obj).then(data => {
      that.month = that.formatDate(data.value);
      console.log("测试");
    }).catch(eror => {
      console.log(eror);
    });
  }
  formatDate(date) {
    if (date) {
      let _date = new Date(date.replace(/-/g, "/"));
      let _y = _date.getFullYear();
      let _m = _date.getMonth() + 1;
      let _d = _date.getDate();
      return _y + "-" + (_m < 10 ? "0" + _m : _m) + "-" + (_d < 10 ? "0" + _d : _d);
    } else {
      return date;
    }
  }

  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.baseService.arrayData.length) {
      if (that.infiniteScroll) {
        that.infiniteScroll.disabled = true;
      }

    }
      that.PageNumber++;
      this.LoadData(that.PageNumber);
  }

  LoadData(PageNumber) {
    var that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }

    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;

    body.ConfigName = "GetProductPurchaseUnApprovalList";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let typeObj = {};
    //ExamineState  1 审批通过  2 审批拒绝  3 待审批   4 无需审批
    typeObj["chineseName"] = that.auditsearchValue;
    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {

      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.baseService.arrayData = [];
        // that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {
        if (that.infiniteScroll) {
          that.infiniteScroll.complete();
        }
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas = data.Status.Status.Datas;
        if (data.Status && data.Status.Datas) {
          data.Status.Datas.forEach(function (item) {
            item["isCheck"] = false;
            item["productShow"] = false;
            that.baseService.arrayData.push(item);
          });
          that.baseService.arrayData.forEach(item=>{
            item.PurchaseDate=item.PurchaseDate.replace(/-/g, "/");
          });
          that.dataArrayList = that.baseService.arrayData;
          console.log(that.dataArrayList, "dataArrayList");
          console.log("arrarydata", that.baseService.arrayData);
          /****上拉加载数据begin****/
          that.RecordCount = data.Status.Status.RecordCount;
          if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.baseService.arrayData.length) {
            // that.infiniteScroll.disabled = true;
            if (that.infiniteScroll) {
              that.infiniteScroll.disabled = true;
            }
          } else {
            if (that.infiniteScroll) {
              that.infiniteScroll.disabled = false;
            }
          }
          /****上拉加载数据end****/
        }
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      // console.log(error);
    });
  }

  /**
  * 全选状态切换
  */
  EventCheckAllToggle() {
    console.log("EventCheckAllToggle");
    const that = this;
    if (that.baseService.FixedSubmitBtn["isCheckAll"]) {
      that.dataArrayList.forEach(items => {
        console.log(items, "集合");
        items.isCheck = true;
      });
    } else {
      that.dataArrayList.forEach(items => {
        items.isCheck = false;
      });
    }
  }
}
